import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { Router , RouterModule } from '@angular/router';
import { UserService } from '../../../../_services/user.service';
import { MobileOtpService } from '../../../../_services/mobile-otp/mobile-otp.service';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-validate-phone',
  templateUrl: './validate-phone.component.html',
  styleUrls: ['./validate-phone.component.scss'],
})
export class ValidatePhoneComponent implements OnInit {
  fromEmailValidate = false;
  phone: any;
  userData: any;
  email: string;
  isAcmic: boolean;
  constructor(
    private router: Router,
    private userService: UserService,
    private mobileOtpService: MobileOtpService,
    private acmicService: AcmicService,
    private alertService: AlertService
  ) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.userService.$user.subscribe((user) => {
      this.userData = user.userDetails;
      this.phone = this.userData.phone
        ? this.maskPhone(this.userData.phone)
        : null;
      this.email = this.userData.email ? this.userData.email : '';
    });
  }
  maskPhone(phn) {
    const len = phn.length;
    return '*'.repeat(len - 4) + phn.substr(len - 4);
  }
  sendOtp(): void {
    this.mobileOtpService
      .generatePasscode(this.userData.phone)
      .subscribe((resp) => {
        if (resp) {
          this.router.navigate(['/signup', 'phone-otp']);
        } else {
          this.alertService.error('PROBLEM_SENDING_OTP', false);
        }
      });
  }
  backToEmailValidateScreen(): void {
    this.router.navigate(['/signup', 'validate-account-email-phone']);
  }

  sendToAccountVerification(): void {
    this.router.navigate(['signup', 'acount-verification']);
  }
}
